<template>
  <div
    v-if="useLongArrow"
    :class="[
      'icon-container',
      'sort-arrow',
      rotateDirection,
      selectedSort === currentSort ? 'active' : '',
    ]"
  >
    <SouthIcon />
  </div>
  <v-icon
    v-else
    size="21px"
    class="sort-arrow"
    :class="{ active: selectedSort === currentSort }"
    :icon="selectedSortDirection === downArrowSortDirection
      || selectedSort !== currentSort
      ? '$chevron-down' : '$chevron-up'"
  />
</template>

<script setup>
import { computed } from 'vue';
import SouthIcon from '@/assets/south.svg?component';

const props = defineProps({
  currentSort: {
    type: String,
    required: true,
  },
  downArrowSortDirection: {
    type: String,
    required: true,
  },
  selectedSortDirection: {
    type: String,
    required: true,

  },
  selectedSort: {
    type: String,
    required: true,
  },
  useLongArrow: {
    type: Boolean,
    default: false,
  },
});

const rotateDirection = computed(() => (
  (props.selectedSortDirection === props.downArrowSortDirection
        || props.selectedSort !== props.currentSort) ? '' : 'rotate-up'));
</script>

<style scoped lang="less">
.sort-arrow {
  opacity: 0;
  transition: all 0.2s;

  &.active {
    opacity: 1;

    &.desc {
      transform: rotate(180deg);
    }
  }
}

.icon-container {
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 4px;

  opacity: 0;
  transition: all 0.2s;

  &.active {
    opacity: 1;
  }

  &.rotate-up {
    transform: rotate(180deg);
  }
}
</style>
